export const PRIVACY_POLICY_URL = 'https://giftee.co.jp/privacypolicy/'
